<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_dahsolar.jpg" data-offset="0">
      <div class="container">
        <h1>DAH SOLAR</h1>
        <h2>MÓDULOS</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                A Dah Solar (Anhui Daheng Energy Technology Co., Ltd) fica localizada na cidade de
                Hefei, próximo a Xangai, e possui uma área de 140.000 metros quadrados. É uma
                empresa de alta tecnologia especializada em desenvolvimento e fabricação de módulos
                solares, construção, operação e manutenção de centrais solares.<br><br>

                &nbsp;&nbsp;Todos os seus produtos foram aprovados por certificação internacional
                como TUV, CE, CEC, INMETRO, FIDE etc. Já está enraizada no mercado chinês, ao mesmo
                tempo, estão explorando ativamente o mercado internacional e estabelecendo a rede de
                vendas em mais de 100 países em todo o mundo, com produtos incluindo painéis solares
                mono e poli e módulo de alta eficiência, em uma solução de sistema solar, como na
                rede, fora da rede e sistemas solares completos híbridos.<br><br>

                &nbsp;&nbsp;A indústria investe continuamente na produção e desenvolvimento de seus
                produtos e já ganhou mais de 100 patentes no momento. O módulo PV inteligente e a
                plataforma de monitoramento em nuvem desenvolvidos pela DAH Solar estão na vanguarda
                da indústria solar.<br><br>


                &nbsp;&nbsp;Possuindo o equipamento de produção automática mais avançado do mundo,
                para uso de tecnologia de produção rigorosa e sistema de controle de qualidade para
                garantir a qualidade dos produtos fabricados perfeitos.<br><br>


                &nbsp;&nbsp;A DAH Solar possui equipamentos para controlar rigorosamente a qualidade
                do produto. Seguindo o princípio comercial de benefícios mútuos, possuem uma ótima
                reputação entre os clientes por seus produtos de extrema qualidade e preços
                competitivos.
              </p>
              <img :src="require('Assets/images/photo_dahsolar1.jpg')">
              <img :src="require('Assets/images/photo_dahsolar2.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Dahsolar',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_dahsolar.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
